import { CurrencyCode } from "web_myplann/Shared/constants";

export const getCurrencyLocale = (
	currencyCode?: CurrencyCode | string | null,
): string => {
	switch (currencyCode) {
		case CurrencyCode.EUR:
			return "sk-SK";
		case CurrencyCode.CHF:
			return "fr-CH";
		case CurrencyCode.GBP:
			return "en-GB";
		case CurrencyCode.USD:
			return "en-US";
		case CurrencyCode.PLN:
			return "pl-PL";
		default:
			return "cs-CZ";
	}
};
